import React from "react";

export default function LogoBlock({ logo, logoName, onClick }) {
  return (
    <div
      className=" w-full flex items-center justify-start hover:bg-gray-100 rounded-lg cursor-pointer py-2 md:py-3 px-2 md:px-4 md:mx-1 transition duration-200"
      onClick={onClick}
    >
      <div className="text-primary hover:text-primary/80 text-3xl md:mr-2">
        {logo}
      </div>
      <p className="text-md text-gray-800 md:flex hidden">{logoName}</p>
    </div>
  );
}
